import React, { Component } from 'react'

export default ({ className, width, height, ...rest }) => {
  return (

    <svg className={className} {...rest} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 38" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>pause</title>
      <path d="M24.66,11.4h-3V26.6h3Z" fill="#f1f1f1"/>
      <path d="M16.3,11.4h-3V26.6h3Z" fill="#f1f1f1"/>
      <path d="M19,1.14A17.9,17.9,0,1,0,31.62,6.38,17.83,17.83,0,0,0,19,1.14ZM19,38A19.14,19.14,0,0,1,5.55,32.45,18.91,18.91,0,0,1,0,19,19.14,19.14,0,0,1,5.55,5.55,18.91,18.91,0,0,1,19,0,19.14,19.14,0,0,1,32.45,5.55,18.91,18.91,0,0,1,38,19a19.14,19.14,0,0,1-5.55,13.45A18.91,18.91,0,0,1,19,38Z" fill="#f1f1f1"/>
    </svg>


  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/PauseButton.js